<ngx-select [allowClear]="false" [items]="items" optionValueField="value" optionTextField="name"
    [autoClearSearch]="false" [(ngModel)]="importants" placeholder="Total"
    (select)="changeImportants($event)">

    <ng-template ngx-select-option-not-found let-input>
        "{{input}}" no encontrado
    </ng-template>

</ngx-select>